import { ContentfulProfileSectionAddtl } from 'ContentfulDefaults/types/profileAddtl';

export const profileAddtl: {
  profile_section_addtl: ContentfulProfileSectionAddtl;
} = {
  profile_section_addtl: {
    contentful_name: 'Profile Section Addtl (DEFAULT DO NOT CHANGE)',
    provider_preferences: {
      contentful_name: '[DEFAULT] Provider Preferences Card',
      name: 'Provider Preferences',
      tooltips: {
        name: {
          text: "A network is a group of doctors and hospitals with which a medical plan has negotiated lower costs. You'll likely pay much less to see an in-network provider than an out-of-network provider.",
          title: 'Provider Preferences',
          underline: 'Provider Preferences',
        },
      },
      yes_label: 'Yes',
      no_label: 'No',
      questions: {
        11: {
          question:
            'If it could save you money, would you be willing to choose a medical plan with fewer in-network doctors and hospitals in your area?',
          tooltip: {
            name: {
              text: 'A narrow network covers fewer providers, but may offer lower premiums. ALEX may still highlight a plan with a narrow network if there are substantial cost savings.',
              title: '',
              underline: 'fewer in-network doctors and hospitals',
            },
          },
        },
        12: {
          question: 'Will you need access to doctors and hospitals outside of your home region?',
          tooltip: {
            name: {
              text: 'A national network covers providers all over the country. This may be important if you travel a lot, work remotely, or are covering a child who lives elsewhere.',
              title: '',
              underline: 'outside of your home region',
            },
          },
        },
        13: {
          question:
            'If it could save you money, would you be willing to choose a plan that requires a referral from your primary care provider before seeing a specialist?',
          tooltip: {
            name: {
              text: "Certain plan types coordinate all care through your primary care provider. This means you'll need to get their recommendation to see a specialist, rather than seeking one out yourself.",
              title: '',
              underline: 'referral from your primary care provider',
            },
          },
        },
      },
    },
    medicare_info_card: {
      contentful_name: 'Medicare Info Section (DEFAULT DO NOT CHANGE)',
      profile_side_panel_header: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [
                  {
                    type: 'bold',
                  },
                ],
                value: 'Want to learn about Medicare?',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      profile_side_panel_details: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: 'ALEX can help you or a loved one choose the right plan.',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      profile_side_panel_button_text: 'Visit ALEX Medicare',
      profile_callout_question: 'Have you signed up for Medicare yet?',
      profile_callout_button_options: {
        no: 'No',
        yes: 'Yes',
      },
      profile_callout_learn_more:
        'Want to learn more about Medicare and how to get started? Click the button below to open ALEX Medicare in another tab.',
      my_alex_health: {
        profile_side_panel_header: {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'bold',
                    },
                  ],
                  value: 'Want to learn about Medicare, too?',
                  nodeType: 'text',
                },
              ],
              nodeType: 'paragraph',
            },
          ],
          nodeType: 'document',
        },
        profile_side_panel_button_text: 'Learn more',
        profile_callout_learn_more:
          "If you'd like a refresher on what Medicare covers so you can compare your options, ALEX can help with personalized guidance. Click the button below to open MyALEXHealth.com in a new tab.",
      },
      profile_callout_tooltips: {
        name: {
          text: 'Medicare is a federal program that provides health insurance, primarily to people 65 and older. You may be eligible sooner if you have certain disabilities or diseases.',
          title: 'Medicare',
          underline: 'Medicare',
        },
      },
      profile_callout_name: 'Medicare',
      text_notes: [
        {
          plan_year: '2026',
          short_text: {
            nodeType: 'document',
            data: {},
            content: [
              {
                nodeType: 'paragraph',
                content: [
                  {
                    nodeType: 'text',
                    value: 'We can include a custom text note here up to 140 characters!',
                    marks: [],
                    data: {},
                  },
                ],
                data: {},
              },
            ],
          },
          long_text: {
            nodeType: 'document',
            data: {},
            content: [
              {
                nodeType: 'paragraph',
                content: [
                  {
                    nodeType: 'text',
                    value: 'Additional information can go here - up to 5000 characters!',
                    marks: [],
                    data: {},
                  },
                ],
                data: {},
              },
            ],
          },
          button_text: 'Read more',
        },
      ],
      pronoun_map: {
        i: '',
        they: '',
        you: '',
      },
    },
    profile_eligibility_rules: [
      {
        plan_year: '2026',
        long_text: {
          nodeType: 'document',
          data: {},
          content: [
            {
              nodeType: 'paragraph',
              data: {},
              content: [
                {
                  nodeType: 'text',
                  value:
                    'Eligibility rules can be added here and will appear in a tooltip next to the eligibility section header.',
                  marks: [],
                  data: {},
                },
              ],
            },
          ],
        },
      },
    ],
  },
};
